import { render, staticRenderFns } from "./shopInfo.vue?vue&type=template&id=74ddcdf8&scoped=true"
import script from "./shopInfo.vue?vue&type=script&lang=js"
export * from "./shopInfo.vue?vue&type=script&lang=js"
import style0 from "./shopInfo.vue?vue&type=style&index=0&id=74ddcdf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ddcdf8",
  null
  
)

export default component.exports